import React from 'react';
import HeroSection from '../components/common/HeroSection';
import ContactForm from '../components/contact/ContactForm';

const breadcrumb = [
  { key: 'nav.home',    path: '/' },
  { key: 'nav.contact', path: null },
];

const ContactUs = () => (
  <>
    <HeroSection
      titleKey="contact.title"
      subtitleKey="contact.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <ContactForm />
  </>
);

export default ContactUs;
